export enum ClosedPeriodOperationType {
  Enrollment = 1,
  Contribution = 2,
  PaymentApproval = 3
}
